import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function Markdown({ children }) {
  return (
    <div className="prose prose-invert max-w-none text-sm
      [&_h1]:heading-mono [&_h1]:amber [&_h1]:uppercase
      [&_h2]:heading-mono [&_h2]:amber [&_h2]:uppercase
      [&_h3]:heading-mono [&_h3]:amber
      [&_a]:amber [&_a]:underline
      [&_strong]:amber
      [&_code]:text-[#4AF626] [&_code]:bg-black [&_code]:px-1
      [&_ul]:list-disc [&_ul]:pl-6
      [&_ol]:list-decimal [&_ol]:pl-6
      [&_blockquote]:border-l-2 [&_blockquote]:border-[#FFB000] [&_blockquote]:pl-3 [&_blockquote]:text-[#A0A0A0]">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children || ""}</ReactMarkdown>
    </div>
  );
}
